// Identidade visual do portal de gestão das clínicas.
export const portalBrand = {
    light: '#f8f8f8',
    main: '#103B66',
    accent: '#1976D2',
    accentLight: '#EAF3FC',
    dark: '#103B66',
    border: '#d4d4d4',
    muted: '#ececec'
};
